export const ALLOCATION_REQUEST_PRICE_MARGIN = 20;
